import { Box, Icon, IconProps, Typography } from '@branch-messenger/willow-ui'
import { FC } from 'react'

import {
  CommonProps,
  FeatureHeaderProps,
  FeatureListContainerProps,
  FeatureListProps,
} from './types'

export const FeaturesListContainer: FC<FeatureListContainerProps> = ({
  children,
  title,
  ...props
}) => {
  return (
    <Box $display="flex" $direction="column" $align="initial" $gap={4}>
      {!!title && (
        <Typography $size="lg" $bold>
          {title}
        </Typography>
      )}
      <Box
        as="ul"
        $display="flex"
        $direction="column"
        $gap={6}
        $p={1}
        $m={0}
        {...props}
      >
        {children}
      </Box>
    </Box>
  )
}

export const FeaturesListItem: FC<CommonProps> = ({ children }) => {
  return (
    <Box as="li" $display="flex" $gap={4} $fullWidth>
      {children}
    </Box>
  )
}

export const FeaturesListItemIcon: FC<IconProps> = props => {
  return (
    <Box $display="flex" $flexShrink={0}>
      <Icon {...props} size={6} />
    </Box>
  )
}

export const FeaturesListItemContent: FC<CommonProps> = ({ children }) => {
  return (
    <Box $display="flex" $direction="column" $align="initial" $gap={1}>
      {children}
    </Box>
  )
}

export const FeaturesListItemHeader: FC<FeatureHeaderProps> = ({
  children,
  bold = true,
}) => {
  return <Typography $bold={bold}>{children}</Typography>
}

export const FeaturesListItemDescription: FC<CommonProps> = ({ children }) => {
  return (
    <Typography $color="textMuted" $size="xs">
      {children}
    </Typography>
  )
}

export const FeaturesList: FC<FeatureListProps> = ({ features }) => {
  return (
    <FeaturesListContainer>
      {features.map(feature => (
        <FeaturesListItem key={feature.title}>
          <FeaturesListItemIcon Icon={feature.icon} />
          <FeaturesListItemContent>
            <FeaturesListItemHeader bold={!!feature.description}>
              {feature.title}
            </FeaturesListItemHeader>
            {feature.description && (
              <FeaturesListItemDescription>
                {feature.description}
              </FeaturesListItemDescription>
            )}
          </FeaturesListItemContent>
        </FeaturesListItem>
      ))}
    </FeaturesListContainer>
  )
}
